import { graphql } from 'parkdepot-shared/gql'

const B2C_GET_ORDER_BY_ID = graphql(`
    query B2CGetOrderById($order_id: String!) {
        b2c_get_order_by_id(order_id: $order_id) {
            ...B2COrderResponse
        }
    }
`)

export default B2C_GET_ORDER_BY_ID
